import { AbpProvider } from 'components/providers';
import { OverlayProvider } from 'components/feedback/Overlay/OverlayProvider';
import { Toaster } from 'components/feedback/Toaster';
import { ReferentialProvider } from 'features/referentials/contexts';
import { RoleProvider } from 'features/auth/contexts/RoleContext';
import { ImpersonationBanner } from 'features/impersonation/ImpersonationBanner';
import { AppRoutes } from 'routes/AppRoutes';

export default function App() {
  return (
      <ReferentialProvider>
        <AbpProvider>
          <RoleProvider>
            {/* OverlayProvider en dernier : les panels/dialogs sont rendus comme frères
                de children, ils doivent donc être SOUS les contextes (Role, Abp, Referential)
                pour que leur contenu (ex : historique -> ActivitySegments -> useRoleCan) y accède. */}
            <OverlayProvider>
              <ImpersonationBanner />
              <AppRoutes />
              <Toaster />
            </OverlayProvider>
          </RoleProvider>
        </AbpProvider>
      </ReferentialProvider>
  );
}
